import ResourcesModule from '../../resources/resources';
import ServicesModule from '../../services/services';
import ConfigsModule from '../../configs/configs';
import template from './campaignsTargeting.jade';
import {getProxyPrefix, checkHttpsAndWrapUrlsInCorsProxy} from '../../common/util/url-util'
import countriesEN from '../../configs/localization/countriesEN';

export class CampaignsTargetingController {
  /* @ngInject */
  constructor($filter, $state, $stateParams, currentGame, currentUser, setProgressBar, Upload, TargetingResource, ggTable, $scope, notify, $auth, $http, $timeout){
    this.translate = $filter('translate');
    this.translateWith = $filter('translateWith');
    this.$stateParams = $stateParams;
    this.Upload = Upload;
    this.$auth = $auth;
    this.$http = $http
    this.$scope = $scope;
    this.ggTable = ggTable;
    this.$timeout = $timeout;

    this.activeUploader = undefined;
    this.setProgressBar = setProgressBar;

    currentGame.subscribe(game => this.game = game);
    currentUser.subscribe(user => this.user = user);
    this.TargetingResource = TargetingResource;
    this.notify = notify;
    this.file = undefined;
    this.deviceModelFile = undefined;
    this.metrosFile = undefined;

    this.dayPartsTable = new ggTable({count: 30});
    this.dayHours = _.range(24);
    this.tableAllHourCheckboxes = _.reduce(_.range(24), function(result, key) {
      result[key] = false
      return result
    }, {});

    this.tableAllDayCheckboxes = _.reduce(_.range(1, 8), function(result, key) {
      result[key] = false
      return result
    }, {});

    this.calculateAllHourCheckboxesTable();
    this.calculateAllDayCheckboxesTable();
    this.checkDayPartAssignment();

    this.dayPartsTable.loadData(this.campaign.targetings.dayParts);

    this.isTargetingCountryOccupy = !_.isEmpty(this.campaign.targetings.countries);
    this.shouldDisplayRegions = !_.isEmpty(this.campaign.targetings.countries) && (_.includes(this.campaign.targetings.countries, 'US') || _.includes(this.campaign.targetings.countries, 'AU') || _.includes(this.campaign.targetings.countries, 'IN'));
    let countriesKeys = _.keys(countriesEN);
    this.countryCodePossibleValuesOptions = countriesKeys.map(option => {
          return {
            value: option,
            name: this.translate(`countryCodes.${option}`)
          };
        });

    this.deviceTypePossibleValuesOptions = [
      {
        name: this.translate('Smartphone'),
        value: 'Smartphone'
      },
      {
        name: this.translate('Tablet'),
        value: 'Tablet'
      },
      {
        name: this.translate('Others'),
        value: 'Others'
      }
    ];

    this.cityOptions = [];
    this.regionOptions = [];
    this.osVersionOptions = [];
    this.sspChannelsOptions = [];

    this.initTargetingData();

    this.osTypeOptions = [
      {
        name: this.translate('iOS'),
        value: 'iOS'
      },
      {
        name: this.translate('Android'),
        value: 'Android'
      },
      {
        name: this.translate('os_all'),
        value: 'all'
      }];

    this.connectionTypeOptions = [
      {
        name: this.translate('connection_type_all'),
        value: 'all'
      },
      {
        name: this.translate('connection_type_wifi_only'),
        value: 'WIFI'
      }];

    this.deviceIdTypeOptions = [
      { name: this.translate('traffic_type_all'), value: 'all' },
      { name: this.translate('traffic_type_with_id'), value: 'IDFA' },
      { name: this.translate('traffic_type_without_id'), value: 'IDFV' },
      { name: this.translate('traffic_type_ip'), value: 'IP' }
    ];

    this.segmentTrafficTypes = [
      { name: this.translate('traffic_type_all'), value: 'All' },
      { name: this.translate('traffic_type_with_id'), value: 'IDFA' },
      { name: this.translate('traffic_type_without_id'), value: 'IDFV' },
      { name: this.translate('traffic_type_ip'), value: 'IP' }
    ];
  }

  shouldDisplayDma() {
    return !_.isEmpty(this.campaign.targetings.countries) && (_.includes(this.campaign.targetings.countries, 'US'));
  }

  getSegmentName(segmentId) {
    if (!Array.isArray(this.segments)) {
      return `Segment#${segmentId}`;
    }

    const segment = this.segments.find(s => s.id === segmentId);
    return segment ? segment.name : `Segment#${segmentId}`;
  }

  isRequired() {
    return this.campaign.campaign_advertising_type === 'UserAcquisition';
  }

  isFrequencyRule2Required() {
    return this.campaign.frequency_caps.rule[1] && (this.campaign.frequency_caps.rule[1].interval_in_hours || this.campaign.frequency_caps.rule[1].times);
  }

  isFrequencyImpressionRule2Required() {
    return this.campaign.frequency_caps.impression[1] && (this.campaign.frequency_caps.impression[1].interval_in_hours || this.campaign.frequency_caps.impression[1].times);
  }

  handleNewFile(newFiles) {
    if (newFiles.length <= 0) {
      return;
    }

    this.activeUploader = "bundleIds";
    this.setProgressBar(this, newFiles.length, 0);
    this.Upload.upload({
      url: `/api/v1/campaigns/upload/targeting/parse_csv_file`,
      headers: {Authorization: 'Bearer ' + this.$auth.getToken(), 'Requested-From-Component': 'pepapi-frontend'},
      data: {file: newFiles[0]}
    }).then((res) => {
      this.setProgressBar(this, newFiles.length, 1);
      this.campaign.targetings.bundleIdsFileExist = false; // unset previously uploaded file url
      this.campaign.targetings.bundleIdsCsvContent = _.uniqBy(res.data, s => s.toLowerCase());
    })
  }


  handleNewDeviceModelsFile(newFiles) {
    if (newFiles.length <= 0) {
      return;
    }

    this.activeUploader = "deviceModels";
    this.setProgressBar(this, newFiles.length, 0);
    this.Upload.upload({
      url: `/api/v1/campaigns/upload/targeting/parse_csv_file`,
      headers: {Authorization: 'Bearer ' + this.$auth.getToken(), 'Requested-From-Component': 'pepapi-frontend'},
      data: {file: newFiles[0]}
    }).then((res) => {
      this.setProgressBar(this, newFiles.length, 1);
      this.campaign.targetings.deviceModelsFileExist = false; // unset previously uploaded file url
      this.campaign.targetings.deviceModelsCsvContent = res.data;
    })
  }

  handleNewDmaCodesFile(newFiles) {
    if (newFiles.length <= 0) {
      return;
    }

    this.activeUploader = "metros";
    this.setProgressBar(this, newFiles.length, 0);
    this.Upload.upload({
      url: `/api/v1/campaigns/upload/targeting/parse_dma_codes_file`,
      headers: {Authorization: 'Bearer ' + this.$auth.getToken(), 'Requested-From-Component': 'pepapi-frontend'},
      data: {file: newFiles[0]}
    }).then((res) => {
      this.setProgressBar(this, newFiles.length, 1);
      this.campaign.targetings.metrosFileExist = true;
      this.campaign.targetings.metrosCsvContent = _.uniq(res.data);
    }).catch((err) => {
      this.setProgressBar(this, newFiles.length, 1);
      this.resetMetros();
      this.notify.apiError(err);
    });
  }

  initTargetingData = () => {
    this.initSsps();
    this.initSspChannels();
    this.initCities();
    this.initRegions();
    this.initOsVersions();
  }

  resetMetros() {
    this.campaign.targetings.metros = [];
    this.campaign.targetings.metrosFileExist = false;
    this.campaign.targetings.metrosCsvContent = undefined;
    this.campaign.targeting_groups.metros = undefined;
    this.metrosFile = undefined;
  }

  onCountriesChange() {
    this.isTargetingCountryOccupy = !_.isEmpty(this.campaign.targetings.countries);
    this.shouldDisplayRegions = !_.isEmpty(this.campaign.targetings.countries) && (_.includes(this.campaign.targetings.countries, 'US') || _.includes(this.campaign.targetings.countries, 'AU') || _.includes(this.campaign.targetings.countries, 'IN'));
    if (!this.shouldDisplayRegions) {
      this.campaign.targetings.regions = [];
    }
    if (!this.shouldDisplayDma()) {
      this.resetMetros();
    }
    this.fetchCities();
    this.fetchRegions();
  }

  shouldDisplaySspChannels() {
    const sspNonEmpty = !_.isEmpty(this.campaign.targetings.ssps);
    const sspIsNotExcluded = !this.campaign.targeting_groups.ssps;
    const sspChannelsNonEmpty = !_.isEmpty(this.sspChannelsOptions);

    return sspNonEmpty && sspIsNotExcluded && sspChannelsNonEmpty;  }

  roundFrequencyCap(type, value) {
    if (value) {
      this.campaign.frequency_caps[type].interval_in_hours = _.floor(value, 1);
    }
  }

  formatTargetingCityData(cityTargeting) {
    return cityTargeting.map(option => {
        return {
          value: option.city,
          name: this.translate(`${option.city}, ${option.country_code}`),
          id: option.id
        };
    });
  }

  formatTargetingRegionData(regionTargeting) {
    return regionTargeting.map(option => {
        return {
          value: `${option.country_code}_${option.region}`,
          name: this.translate(`${option.name} (${option.region})`),
          id: option.id
        };
    });
  }

  formatTargetingSspChannelsData(sspChannelTargeting) {
    return sspChannelTargeting.map(option => {
      return {
        value: option.channel,
        name: this.translate(`${_.upperFirst(option.channel)}, ${option.ssp}`),
      };
    });
  }

  formatSspData(ssp) {
    return ssp.map(option => {
      return {
        value: option.name_id,
        name: option.name,
      };
    });
  }

  checkDayPartAssignment() {
    this.dayPartAssigned = false;
    const vm = this;
    _.reduce(this.tableAllHourCheckboxes, function(result, value, key) {
      if (!value) {
        vm.dayPartAssigned = true;
      }
    }, {});
  }

  calculateAllHourCheckboxesTable() {
    const cmp = this.campaign;
    this.tableAllHourCheckboxes = _.reduce(this.tableAllHourCheckboxes, function(result, value, key) {
      result[key] = _.chain(cmp.targetings.dayParts)
      .map(dp => dp[key])
      .every(b => b === true)
      .value();
      return result
    }, {});
  }

  calculateAllDayCheckboxesTable() {
    const cmp = this.campaign;
    this.tableAllDayCheckboxes = _.reduce(this.tableAllDayCheckboxes, (result, value, key) => {
      const matchedDayPart = _.find(cmp.targetings.dayParts, dp => dp.day === parseInt(key));
      if (matchedDayPart) {
        const {day, $$hashKey, ...row} = matchedDayPart
        const rowValues = row ? _.values(row) : [];
        result[parseInt(key)] = rowValues.length === 24 && _.every(rowValues, b => b === true);
      }
      return result
    }, {});
  }

  daySortOrder(dayPartsData) {
    const order = {2: 0, 3: 1, 4: 2, 5: 3, 6: 4, 7: 5, 1: 6};
    return order[dayPartsData.day];
  }

  dayByValue(numValue) {
    switch(numValue) {
      case 1:  return 'Sunday';
      case 2:  return 'Monday';
      case 3:  return 'Tuesday';
      case 4:  return 'Wednesday';
      case 5:  return 'Thursday';
      case 6:  return 'Friday';
      case 7:  return 'Saturday';
      default: return 'Unknown';
    }
  }

  onChangeDayPartHour(dayPartsData, hour) {
    dayPartsData[hour] = !dayPartsData[hour];
    this.campaign.targetings.dayParts = _.map(this.campaign.targetings.dayParts, dp => (dp.day === dayPartsData.day) ? dayPartsData : dp);
    this.calculateAllHourCheckboxesTable();
    this.calculateAllDayCheckboxesTable();
    this.checkDayPartAssignment();
  }

  onChangeAllDayPartsByHour(hour) {
    const allHourVal = this.tableAllHourCheckboxes[hour];
    this.campaign.targetings.dayParts = _.map(this.campaign.targetings.dayParts, ({[hour]: hourVal, ...rest}) => {
      return {
        ...rest,
        [hour]: allHourVal
      }
    });
    this.calculateAllDayCheckboxesTable();
    this.calculateAllHourCheckboxesTable();
    this.dayPartsTable.loadData(this.campaign.targetings.dayParts);
    this.checkDayPartAssignment();
  }

  defaultDayPart = (day, hourValue) => {
    const hours = _.reduce(_.range(24), function(result, key) {
      result[key] = hourValue
      return result
    }, {});
    return {...hours, day};
  }

  onChangeAllDayPartsByDay(dayPartsData) {
    const allDayVal = !this.tableAllDayCheckboxes[dayPartsData.day];
    this.campaign.targetings.dayParts = _.map(this.campaign.targetings.dayParts, dp => (dp.day === dayPartsData.day) ? this.defaultDayPart(dayPartsData.day, allDayVal) : dp);
    this.calculateAllHourCheckboxesTable();
    this.calculateAllDayCheckboxesTable();
    this.dayPartsTable.loadData(this.campaign.targetings.dayParts);
    this.checkDayPartAssignment();
  }

  initCities = () => {
    if (!_.isEmpty(this.campaign.targetings.countries)) {
      var self = this;
      this.TargetingResource.one('cities').get(
          {country_code: this.campaign.targetings.countries})
      .then(cityTargeting => {
        self.cityOptions = self.formatTargetingCityData(cityTargeting);
        if (this.campaign.targetings.cities.length > 99) {
          self.cityOptions.push({
            value: '...',
            name: '...',
            id: -1
          })
        }
      });
    }
  }

  initRegions = () => {
    if (!_.isEmpty(this.campaign.targetings.countries)) {
      var self = this;
      this.TargetingResource.one('regions').get({country_code: this.campaign.targetings.countries})
      .then(regionTargeting => {
        self.regionOptions = self.formatTargetingRegionData(regionTargeting);
      });
    }
  }

  initSsps = () => {
    var self = this;
    this.TargetingResource.one('ssps').get()
      .then(sspChannelTargeting => {
        self.sspTypeOptions = self.formatSspData(sspChannelTargeting);
    });
  }

  initSspChannels = () => {
    if(!_.isEmpty(this.campaign.targetings.ssps)) {
      var self = this;
      this.TargetingResource.one('ssp_channels').get(
          {ssp: this.campaign.targetings.ssps})
      .then(sspChannelTargeting => {
        self.sspChannelsOptions = self.formatTargetingSspChannelsData(
            sspChannelTargeting);
      });
    }
  }

  fetchCities = () => {
    var self = this;
    if (!_.isEmpty(this.campaign.targetings.countries)) {
      this.TargetingResource.one('cities').get({country_code: this.campaign.targetings.countries})
      .then(cityTargeting => {
        self.campaign.targetings.cities = self.campaign.targetings.cities.filter(
            city => cityTargeting.some(ct => ct.city === city));

        self.cityOptions = self.formatTargetingCityData(cityTargeting)
        .filter(cityOption => !self.campaign.targetings.cities.some(
            city => city === cityOption.value));
      });
    }
  }

  fetchRegions = () => {
    var self = this;
    if (!_.isEmpty(this.campaign.targetings.countries)) {
      this.TargetingResource.one('regions').get({country_code: this.campaign.targetings.countries})
      .then(regionTargeting => {
        self.campaign.targetings.regions = self.campaign.targetings.regions.filter(region => regionTargeting.some(rt => rt.region === region));

        self.regionOptions = self.formatTargetingRegionData(regionTargeting)
        .filter(regionOption => !self.campaign.targetings.regions.some(region => region === regionOption.value));
      });
    }
  }

  fetchSspChannels = () => {
    if(!_.isEmpty(this.campaign.targetings.ssps)) {
      var self = this;
      this.TargetingResource.one('ssp_channels').get(
          {ssp: this.campaign.targetings.ssps})
      .then(sspChannelTargeting => {
        self.campaign.targetings.sspChannels = self.campaign.targetings.sspChannels
          .filter(sspChannel => sspChannelTargeting.some(ct => ct.channel === sspChannel));

        self.sspChannelsOptions = self.formatTargetingSspChannelsData(sspChannelTargeting)
          .filter(sspChannelOption => !self.campaign.targetings.sspChannels.some(sspChannel => sspChannel === sspChannelOption.value));
      });
    }
  }

  formatTargetingOsVersionData(osVersions) {
    return osVersions.map(option => {
        return {
          value: option.version,
          name: this.translate(`${option.device_os} - ${option.version}`),
          id: option.id
        };
    });
  }

  initOsVersions = () => {
    var self = this;
    if (!_.isEmpty(this.campaign.targetings.deviceOs)) {
      this.TargetingResource.one('device-os').get({device_os: this.campaign.targetings.deviceOs})
      .then(osVersions => {
        self.osVersionOptions = self.formatTargetingOsVersionData(osVersions);
      });
    }
  }

  fetchOsVersions = () => {
    if (!_.isEmpty(this.campaign.targetings.deviceOs)) {
      var self = this;
      this.TargetingResource.one('device-os').get({device_os: this.campaign.targetings.deviceOs})
      .then(osVersions => {
        self.campaign.targetings.deviceOsVersion = self.campaign.targetings.deviceOsVersion
        .filter(osVersion => osVersions.some(ov => ov.version === osVersion));

        self.osVersionOptions = self.formatTargetingOsVersionData(osVersions)
        .filter(versionOption => !self.campaign.targetings.deviceOsVersion.some(
            version => version === versionOption.value));
      });
    }
  }

  getExportBundleIdsData() {
    return _.map(this.campaign.targetings.bundleIds, (row) => {
      return { key: row };
    });
  }
  getExportDeviceModelData() {
    return _.map(this.campaign.targetings.deviceModels, (row) => {
      return { key: row };
    });
  }

  getCurrentDmaCodes() {
    return this.campaign.targetings.metrosCsvContent || this.campaign.targetings.metros;
  }

  getExportDmaCodesData() {
    let metros = this.getCurrentDmaCodes();
    return _.map(metros, (row) => {
      return { key: row };
    });
  }
}

export function CampaignsTargetingComponent() {
  return {
    template,
    controller: CampaignsTargetingController,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {
      campaign: '=',
      segments: '='
    },
    bindToController: true
  };
};

export default angular.module('app.components.campaigns.targeting', [
  'ngFileUpload',
  ResourcesModule.name,
  ServicesModule.name,
  ConfigsModule.name
])
  .directive('campaignsTargeting', CampaignsTargetingComponent);



/** WEBPACK FOOTER **
 ** ./src/components/campaigns/campaignsTargeting.js
 **/